import Swiper, { Navigation, Scrollbar, Pagination, EffectFade, Autoplay , Grid } from 'swiper';
import eventBus from '../utils/eventBus';

const initSlider = () => {

  const sliderElements = document.querySelectorAll('.wp-quiz-slider');

  if (sliderElements) {
    sliderElements.forEach(sliderEl => {
      let slider;
      let baseOptions = {
        init: false,
        modules: [Navigation, Scrollbar, Pagination, EffectFade, Autoplay, Grid],
        scrollbar: {
          el: sliderEl.querySelector('.wp-quiz-slider__scrollbar'),
          draggable: true
        },
        pagination: {
          el: sliderEl.querySelector('.wp-quiz-slider__pagination'),
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: sliderEl.querySelector('.wp-quiz-slider__button--next'),
          prevEl: sliderEl.querySelector('.wp-quiz-slider__button--prev'),
        },
      }
      const {sliderSettings} = sliderEl.dataset
      let additionalSettings = {}

      if (sliderSettings) {
        additionalSettings = JSON.parse(sliderSettings)
      }

      slider = new Swiper(sliderEl.querySelector('.wp-quiz-slider__container'), {...baseOptions, ...additionalSettings})

      slider.on('slideChange', (s) => {
        eventBus.emit('wp-quiz-slider-slide-changed', {
          elm: sliderEl,
          slider: s
        })
      })

      slider.init();

      eventBus.on('wp-quiz-step-changed', () => {
        console.log(1)
        slider.slideTo(0)
      });
    });
  }
}

window.addEventListener('DOMContentLoaded', initSlider, { once: true });
